import { render, staticRenderFns } from "./WorldLoader.vue?vue&type=template&id=7a80f8a3&"
import script from "./WorldLoader.vue?vue&type=script&lang=js&"
export * from "./WorldLoader.vue?vue&type=script&lang=js&"
import style0 from "./WorldLoader.vue?vue&type=style&index=0&id=7a80f8a3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports